import extend from "../../services/extend";

/**
 * Used to display header based on scroll direction
 */
export default (vue) => extend(vue, (vue) => {
    return {
        offset: {
            old: 0,
            new: 0,
        },
        init() {
            window.addEventListener('scroll', (event) =>{
                this.offset.new = window.scrollY || document.documentElement.scrollTop;
                // Scrolling direction
                vue.el.dataset.scroll  = this.offset.old < this.offset.new || this.offset.new < vue.el.offsetHeight ? 'down' : 'up';

                // @todo Overwrite when hamburger is opened
                if ( vue.ctx.scope.modules.display.aside === true ) {
                    vue.el.dataset.scroll = "up";
                }

                // Reset the old value
                this.offset.old = this.offset.new;

            }, { capture: true, passive: true });

        }
    }
});